import { DriveFile } from '@/modules/drive/domain/models/DriveFile'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

import { axios, Response } from '../index'
import {
  AccessProfilePermission,
  PersonaAccessInfo
} from './get-folder-share-options'

export interface FilesAndFolders {
  folders: Folder[]
  files: DriveFile[]
  patientName: string
}

export type FolderWithSub = {
  folders?: Folder[]
} & Folder

export interface Folder {
  id: string
  name: string
  personaId: string
  folderVisibility: string
  updatedAt: string
  createdAt: string
  personaInfoSummary: PersonaInfoSummary
  parentFolderId: string
  createdBy: PersonaInfoSummary
  permissions: PersonaAccessInfo[]
  accessProfilePermissions: AccessProfilePermission[]
}

const getFolderFilesAndFolders = (
  personId: string,
  folderId: string | null
): Response<FilesAndFolders> => {
  return axios.get(`/v1/personas/${personId}/folders/${folderId}`)
}

export default getFolderFilesAndFolders
